import { render, staticRenderFns } from "./BkPaginacion.vue?vue&type=template&id=ed0c2c68"
import script from "./BkPaginacion.vue?vue&type=script&lang=js"
export * from "./BkPaginacion.vue?vue&type=script&lang=js"
import style0 from "./BkPaginacion.vue?vue&type=style&index=0&id=ed0c2c68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports